import React from "react";
import {
  Drawer,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import { format, isAfter, parseISO } from "date-fns";

const Sidebar = ({ isOpen, handleClose, creditHistory }) => {
  const getAccordionColor = (expiresAt) => {
    const currentDate = new Date();
    return expiresAt !== null && isAfter(parseISO(expiresAt), currentDate)
      ? "green"
      : "#ee9595";
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose}>
      <Box sx={{ width: 350, padding: "5px 15px" }}>
        {/* Header with close icon */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0.5,
          }}
        >
          <Typography variant="h6">Credit History</Typography>
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ marginBottom: 1 }} />

        {/* Credit history list */}
        {creditHistory.length > 0 ? (
          creditHistory?.map((item) => (
            <Accordion
              key={item?.id}
              sx={{
                border: `1px solid ${getAccordionColor(item?.expires_at)}`,
                mb: 1,
                borderRadius: "3px",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  {item?.amount} Credits -{" "}
                  {item?.credit_type.charAt(0).toUpperCase() +
                    item?.credit_type.slice(1)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <b>Reason:</b> {item?.reason}
                  <br />
                  <b>Created:</b> {format(new Date(item?.created_at), "PPpp")}
                  <br />
                  <b>Expires:</b> {format(new Date(item?.expires_at), "PPpp")}
                  <br />
                  <b>Remaining:</b> {item?.remain} Credits
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          <Typography
            variant="body2"
            sx={{ textAlign: "center", marginTop: 2 }}
          >
            No credit history found.
          </Typography>
        )}
      </Box>
    </Drawer>
  );
};

export default Sidebar;
